import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Checkbox, Box, Button, Container, FormControl, InputLabel, Select, MenuItem, ListItemText, Skeleton, Tooltip, Divider, Rating, Card, CardContent, CardMedia, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import StarIcon from "@mui/icons-material/Star";
import axios from "axios";


const Komik = () => {
  const [komikList, setKomikList] = useState([]);
  const [filters, setFilters] = useState({ genre: [], status: "", type: "", order: "update" });
  const [filterOptions, setFilterOptions] = useState({});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({ prev: false, next: true });

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("filterkomik"));
    if (savedData) {
      setFilters(savedData.filters);
      setPage(savedData.page);
    }
    const fetchFilters = async () => {
      try {
        const response = await axios.get("https://alabada.my.id/komik", {
          headers: { jenis: "list" },
          params: {
            halaman: savedData?.page || 1,
            genre: savedData?.filters.genre || [],
            status: savedData?.filters.status || "",
            type: savedData?.filters.type || "",
            order: savedData?.filters.order || "update",
          },
        });
        setFilterOptions(response.data.filter);
        setKomikList(response.data.manga);
        setPagination(response.data.pagination);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching filter data", error);
        setLoading(false);
      }
    };
    fetchFilters();
  }, []);

  const fetchKomik = async (newPage) => {
    try {
      setLoading(true);
      const response = await axios.get("https://alabada.my.id/komik", {
        headers: { jenis: "list" },
        params: {
          halaman: newPage,
          genre: filters.genre,
          status: filters.status,
          type: filters.type,
          order: filters.order,
        },
      });

      setKomikList(response.data.manga);
      setPagination(response.data.pagination);
      setLoading(false);

      localStorage.setItem("filterkomik", JSON.stringify({ filters, page: newPage }));
    } catch (error) {
      console.error("Error fetching komik data", error);
      setLoading(false);
    }
  };

  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = () => {
    setPage(1);
    fetchKomik(1);
  };

  const handlePrevPage = () => {
    if (pagination.prev) {
      const prevPage = page - 1;
      setPage(prevPage);
      fetchKomik(prevPage);
    }
  };

  const handleNextPage = () => {
    if (pagination.next) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchKomik(nextPage);
    }
  };

  const filterFields = [
    { name: 'status', label: 'Status', value: filters.status, options: filterOptions.status },
    { name: 'type', label: 'Tipe', value: filters.type, options: filterOptions.type },
    { name: 'order', label: 'Urutan', value: filters.order, options: filterOptions.order },
  ];

  return (
    <Container sx={{ p: 2 }}>
      {!loading && (
        <Grid container spacing={2} columns={{ xs: 2, sm: 2, md: 5 }}>
          <Grid size={{ xs: 1, sm: 1, md: 1 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Genre</InputLabel>
              <Select
                multiple
                value={filters.genre}
                onChange={handleFilterChange}
                name="genre"
                renderValue={(selected) => selected.join(", ")}
              >
                {filterOptions.genres?.map((option) => (
                  <MenuItem key={option.id} value={option.value}>
                    <Checkbox checked={filters.genre.includes(option.value)} />
                    <ListItemText primary={option.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {filterFields.map(({ name, label, value, options }) => (
            <Grid size={{ xs: 1, sm: 1, md: 1 }} key={name}>
              <FormControl fullWidth size="small">
                <InputLabel>{label}</InputLabel>
                <Select
                  value={value}
                  onChange={handleFilterChange}
                  name={name}
                  label={label}
                  disabled={loading}
                >
                  {options?.map((option) => (
                    <MenuItem key={option.id} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          ))}

          <Grid size={{ xs: 2, sm: 2, md: 1 }}>
            <Button fullWidth variant="contained" onClick={handleSearch} disabled={loading}>
              Cari
            </Button>
          </Grid>
        </Grid>
      )}

      <Grid container spacing={1} columns={{ xs: 3, sm: 3, md: 5, lg: 6 }} sx={{ pt: 2 }}>
        {loading
          ? Array.from(new Array(12)).map((_, index) => (
              <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1 }} key={index}>
                <Skeleton 
                  variant="rectangular" 
                  width="100%" 
                  sx={{
                    minHeight: {
                      xs: "16vh",
                      sm: "18vh",
                      md: "20vh",
                      lg: "22vh",
                    },
                    maxHeight: {
                      xs: "16vh",
                      sm: "18vh",
                      md: "20vh",
                      lg: "22vh",
                    },
                  }}
                />
              </Grid>
            ))
          : komikList.map((komik, index) => (
              <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1 }} key={index}>
                <Card sx={{ position: "relative" }}>
                  <CardMedia
                    component="img"
                    sx={{
                      objectFit: "fill",
                      minHeight: {
                        xs: "16vh",
                        sm: "18vh",
                        md: "20vh",
                        lg: "22vh",
                      },
                      maxHeight: {
                        xs: "16vh",
                        sm: "18vh",
                        md: "20vh",
                        lg: "22vh",
                      },
                    }}
                    image={komik.image}
                    alt={komik.title}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      backgroundColor: "rgba(0, 0, 0, 0.7)",
                      color: "white",
                      padding: "4px 8px",
                      fontSize: "0.8rem",
                      borderRadius: "4px",
                    }}
                  >
                    {komik.type}
                  </Box>
                  <CardContent>
                    <Typography
                      component={Link}
                      to={`/komik/${komik.link}`}
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "0.8rem",
                        color: "inherit",
                        textDecoration: "none",
                        display: "block",
                      }}
                    >
                      <Tooltip title={komik.title} arrow>
                        <span>{komik.title}</span>
                      </Tooltip>
                    </Typography>
                    <Divider />
                    <Typography sx={{ display: "flex" }}>
                      <Rating
                        name="komik-rating"
                        value={parseFloat(komik.rating) / 2}
                        readOnly
                        precision={0.5}
                        emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                        sx={{ fontSize: "1rem" }}
                      />
                    </Typography>
                    <Divider />
                    <Typography
                      component={Link}
                      to={`/komik/${komik.latestChapter.link}`}
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "0.8rem",
                        color: "inherit",
                        textDecoration: "none",
                      }}
                    >
                      {komik.latestChapter.text}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
      </Grid>

      <Grid container justifyContent="space-between" marginTop={2}>
        <Button variant="contained" onClick={handlePrevPage} disabled={!pagination.prev || loading}>
          Sebelumnya
        </Button>
        <Button variant="contained" onClick={handleNextPage} disabled={!pagination.next || loading}>
          Selanjutnya
        </Button>
      </Grid>
    </Container>
  );
};

export default Komik;
